import React from 'react'
import Link from 'gatsby-link'
import { Container } from 'react-responsive-grid'
import foto from './../components/r.jpg'
import { rhythm, scale } from '../utils/typography'

class Template extends React.Component {
  render() {
    let styleli = {
      display: 'inline-block',
      width: '33%',
      marginBottom: '0px',
      borderRight: '1px solid black',
    }
    let styleli1 = {
      display: 'inline-block',
      width: '33%',
      marginBottom: '0px',
    }
    let link = {
      color: 'black',
      textDecoration: 'none',
      fontWeight: 'bold',
    }
    const { location, children } = this.props
    let header

    let rootPath = `/`
    let rootPath1 = rootPath + `about`
    let rootPath2 = rootPath + `portfolio`
    if (typeof __PREFIX_PATHS__ !== `undefined` && __PREFIX_PATHS__) {
      rootPath = __PATH_PREFIX__ + `/`
      rootPath1 = rootPath + `about`
      rootPath2 = rootPath + `portfolio`
    }

    let e = location.pathname
    if (e === rootPath || e === rootPath1 || e === rootPath2) {
      header = (
        <div
          style={{
            textAlign: 'center',
            background: 'cadetblue',
            marginTop: '-25px',
          }}
        >
          <img
            style={{
              borderRadius: '50%',
              maxWidth: '10%',
              marginBottom: '0px',
              paddingTop: '30px',
            }}
            src={foto}
          />
          <h3
            style={{
              marginTop: '5px',
              fontStyle: 'italic',
              fontWeight: '300',
              color: 'black',
            }}
          >
            Kamarul Risman
          </h3>
          <div
            style={{
              background: 'white',
              margin: 'auto',
              maxWidth: rhythm(24),
              padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
              paddingTop: '0px',
              paddingBottom: '20px',
            }}
          >
            <ul
              style={{
                background: 'white',
                padding: '25px',
                margin: 'auto',
                borderBottom: '1px solid lightgray',
              }}
            >
              <li style={styleli}>
                <Link to={'/'} style={link}>
                  ARTICLE
                </Link>
              </li>
              <li style={styleli}>
                <Link to={'/about'} style={link}>
                  ABOUT
                </Link>
              </li>
              <li style={styleli1}>
                <Link to={'/portfolio'} style={link}>
                  PORTFOLIO
                </Link>
              </li>
            </ul>
          </div>
        </div>
      )
    } else {
      header = (
        <Container
          style={{
            maxWidth: rhythm(24),
            // margin: 'auto',
            padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
            background: 'white',
            paddingBottom: '0px',
          }}
        >
          <Link to={'/'}>← All Articles</Link>
        </Container>
      )
    }
    return (
      <Container
        style={{
          // maxWidth: rhythm(24),
          // padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
          // paddingTop: '0px',
          maxWidth: '100%',
        }}
      >
        {header}
        <Container
          style={{
            maxWidth: rhythm(24),
            margin: 'auto',
            padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
            background: 'white',
            // marginTop: '0',
          }}
        >
          {children()}
        </Container>
      </Container>
    )
  }
}

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.js